module.exports = __webpack_public_path__ + "img/36.6.CODm.7d25982a.png";